var map = {
	"./3.3ton Cabbage Collection.jpeg": 7461,
	"./Beans Prod.jpg": 3382,
	"./Brinjal @ JoburgMkt.jpeg": 7036,
	"./Butternut.jpg": 2419,
	"./Cabbage plantation.jpeg": 2452,
	"./Cutter.jpeg": 7984,
	"./IMG-20250420-WA0002.jpg": 5836,
	"./IMG_20240710_145746.jpg": 8662,
	"./IMG_20240806_122100.jpg": 1879,
	"./IMG_20240806_122914.jpg": 2404,
	"./IMG_20240815_130931.jpg": 3152,
	"./IMG_20240817_110238.jpg": 9314,
	"./IMG_20240817_115716(1).jpg": 9032,
	"./IMG_20240817_115716.jpg": 1924,
	"./IMG_20240817_123458.jpg": 5584,
	"./IMG_20240820_081211.jpg": 1382,
	"./IMG_20240820_081226.jpg": 8616,
	"./IMG_20240821_075451.jpg": 2332,
	"./IMG_20240828_175301.jpg": 6976,
	"./IMG_20240829_142415.jpg": 5341,
	"./IMG_20240918_205209.jpg": 663,
	"./IMG_20240928_084816.jpg": 3107,
	"./IMG_20240928_084825.jpg": 1829,
	"./IMG_20241003_204607.jpg": 2580,
	"./IMG_20241003_205300.jpg": 3045,
	"./IMG_20241013_073327.jpg": 7750,
	"./IMG_20241029_171640.jpg": 1910,
	"./IMG_20241031_144429.jpg": 98,
	"./Spinach Delivery 371.jpg": 1145,
	"./Spinach PnP Delivery.jpg": 8600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6036;